export let aprilUppercase = "GsS9te";
export default {aprilUppercase};